
import Hero from './components/Hero';
import PhoneVerification from './components/PhoneVerification';
import RegionalJobs from './components/RegionalJobs';
import CommunityConnection from './components/CommunityConnection';
import UserBenefits from './components/UserBenefits';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Hero />
      <PhoneVerification />
      <RegionalJobs />
      <CommunityConnection />
      <UserBenefits />
    </div>
  );
}
